'use strict'

import { Crossword } from './crossword.js'
import { Cell, Clue, Grid } from './grid.js'

export class Jpz extends Crossword {
  /**
   * Initialize the JPZ puzzle.
   *
   * @param data [Buffer] the puzzle as a Uint8Array buffer.
   */
  constructor (data = new Uint8Array()) {
    super(data)
  }

  /**
   * Convert the data to a manageable XML string.
   */
  _convertPuzzleToXML () {
    let str = String.fromCharCode.apply(null, new Uint8Array(this._data))

    if (str) {
      var parser = new DOMParser()
      this._xml = parser.parseFromString(str, 'text/xml')
    }
  }

  // Parse the puzzle
  _parsePuzzle () {
    this._convertPuzzleToXML()

    this._setPuzzleData()
    this._setDims()
    this._setCells()
    this._setClues()
  }

  _setPuzzleData () {
    let metadata = this._xml.getElementsByTagName('metadata')[0]

    // Metadata
    if (metadata) {
      let metadataAttrs = {
        'copyright': 'copyright',
        'creator': 'author',
        'notepad': 'notepad',
        'title': 'title'
      }

      Object.keys(metadataAttrs).forEach(key => {
        let ele = metadata.getElementsByTagName(key)[0]
        if (ele && ele.firstChild) {
          let xwKey = metadataAttrs[key]
          this[xwKey] = ele.firstChild.data
        }
      })
    }

    // Instructions are separate from metadata.
    let instr = this._xml.getElementsByTagName('instructions')[0]
    if (instr) {
      this.instructions = instr.firstChild.data
    }
  }

  // Sets the height/width of the puzzle.
  _setDims () {
    let gridEle = this._xml.getElementsByTagName('grid')[0]

    this.grid.height = gridEle.getAttribute('height')
    this.grid.width = gridEle.getAttribute('width')
  }

  // Set the puzzle key array
  _setCells () {
    let xmlCells = Array.prototype.slice.call(
      this._xml.getElementsByTagName('cell')
    )

    var cells = []
    xmlCells.forEach(cell => {
      let cellType = cell.getAttribute('type')
      let is_block = cellType == 'block'
      let x = parseInt(cell.getAttribute('x')) - 1
      let y = parseInt(cell.getAttribute('y')) - 1

      cells.push(new Cell({
        'answer': (is_block ? null : cell.getAttribute('solution')),
        'cellType': cellType,
        'cellNumber': (
          cell.getAttribute('number') ? parseInt(cell.getAttribute('number')) : null
        ),
        'idx': this.grid.idxFromCoords(x, y),
        'x': x,
        'y': y
      }))
    })

    this.grid.cells = cells
  }

  // Sets the puzzle clues.
  _setClues () {
    this._setWords()

    let clues = Array.prototype.slice.call(
      this._xml.getElementsByTagName('crossword')[0].getElementsByTagName('clues')
    )

    var puzzle_clues = []
    clues.forEach(clue_group => {
      let axis = clue_group.getElementsByTagName('title')[0].textContent.trim()
      this.axes.push(axis)

      let group_clues = Array.prototype.slice.call(
        clue_group.getElementsByTagName('clue')
      )

      group_clues.forEach(clue => {
        puzzle_clues.push(new Clue({
          'axis': axis,
          'cells': this.words[clue.getAttribute('word')],
          'clue_string': clue.textContent.trim(),
          'clue_number': clue.getAttribute('number')
          // 'idx': cell.idx,
          // 'x': cell.x,
          // 'y': cell.y
        }))
      })
    })

    this.clues = puzzle_clues
  }

  // Set the words.
  _setWords () {
    let words = Array.prototype.slice.call(
      this._xml.getElementsByTagName('word')
    )

    this.words = {}
    words.forEach(word => {
      let id = word.getAttribute('id')
      let word_attrs = [
        'x', 'y'
      ]

      let cellRange = []
      // cells can be defined through child nodes, or word attributes.
      var cells = Array.prototype.slice.call(
        word.getElementsByTagName('cells')
      )

      cells.forEach(cell => {
        cellRange.push({
          'x': cell.getAttribute('x'),
          'y': cell.getAttribute('y')
        })
      })

      let word_cell_range = {}
      word_attrs.forEach(attr => {
        let val = word.getAttribute(attr)
        if (val) {
          word_cell_range[attr] = val
        }
      })

      if (Object.keys(word_cell_range).length > 0) {
        cellRange.push(word_cell_range)
      }

      this.words[id] = cellRange
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/jpz.js
// module id = 237
// module chunks = 0